import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/74_card_back_panda/74_card_back_panda"
 * Contains 1 texture(s)
 */
export class CardsBacks74CardBackPandaAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/74_card_back_panda/74_card_back_panda';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '74_panda.png'
    ] as const;
}
